import * as React from 'react';
import { SegmentAttributeRange } from '../../../models/segments';

export const useMinMaxSlider = (
  attribute: SegmentAttributeRange,
  initialValues: { min: number | null; max: number | null }
) => {
  const [minValue, setMinValue] = React.useState<number | ''>(initialValues.min || attribute.filters.min);
  const [maxValue, setMaxValue] = React.useState<number | ''>(initialValues.max || attribute.filters.max);
  const [warning, setWarning] = React.useState<string>('');

  const handleSliderChange = (_event: any, value: [number, number]) => {
    setMinValue(value[0]);
    setMaxValue(value[1]);
  };

  React.useEffect(() => {
    if (maxValue === '') {
      setWarning('');
    } else if (minValue < attribute.filters.min) {
      setWarning(`Minimum value is ${attribute.filters.min}`);
    } else if (minValue > attribute.filters.max) {
      setWarning(`Maximum value is ${attribute.filters.max}`);
    } else {
      setWarning('');
    }
  }, [minValue]);

  React.useEffect(() => {
    if (maxValue === '') {
      setWarning('');
    } else if (maxValue < attribute.filters.min) {
      setWarning(`Minimum value is ${attribute.filters.min}`);
    } else if (maxValue > attribute.filters.max) {
      setWarning(`Maximum value is ${attribute.filters.max}`);
    } else {
      setWarning('');
    }
  }, [maxValue]);

  const handleMinChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setMinValue(event.target.value === '' ? '' : Number(event.target.value));
  };

  const handleMaxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setMaxValue(event.target.value === '' ? '' : Number(event.target.value));
  };

  const handleMinBlur = () => {
    if (minValue === '') {
      setMinValue(attribute.filters.min);
    } else if (minValue < attribute.filters.min) {
      setMinValue(attribute.filters.min);
    } else if (minValue > attribute.filters.max) {
      setMinValue(attribute.filters.max);
    }
  };

  const handleMaxBlur = () => {
    if (maxValue === '') {
      setMaxValue(attribute.filters.max);
    } else if (maxValue < attribute.filters.min) {
      setMaxValue(attribute.filters.min);
    } else if (maxValue > attribute.filters.max) {
      setMaxValue(attribute.filters.max);
    }
  };

  return {
    minValue,
    setMinValue,
    maxValue,
    setMaxValue,
    handleSliderChange,
    handleMinChange,
    handleMinBlur,
    handleMaxChange,
    handleMaxBlur,
    warning
  };
};
